export const PUT_REPORTS_DETAIL_ADMIN_MEMO =
  "admin/PUT_REPORTS_DETAIL_ADMIN_MEMO";
export const PUT_REPORTS_DETAIL_ADMIN_MEMO_SUCCESS =
  "admin/PUT_REPORTS_DETAIL_ADMIN_MEMO_SUCCESS";
export const PUT_REPORTS_DETAIL_ADMIN_MEMO_FAILURE =
  "admin/PUT_REPORTS_DETAIL_ADMIN_MEMO_FAILURE";
